/* v8 ignore start */

import { ref } from "vue";
import { useAbility } from "@casl/vue";
// @ts-expect-error: no declaration file for the JS module
import { useAuthStore } from "@switchsystems/coactive-vue-lib";
// @ts-expect-error: no declaration file for the JS module
import { useRotaUsersStore } from "@/store/rotausers";
import {
  userIsOnThisRota,
  agencyIsOnThisRota,
  // @ts-expect-error: no declaration file for the JS module
} from "@/lib/rota/rotauser-functions";

import type { Rota } from "@/types";

export default () => {
  const { can } = useAbility();
  const authStore = useAuthStore();
  const rotaUsersStore = useRotaUsersStore();
  const rotaUser = ref<any | undefined>(undefined);

  const authUserCanAccessRota: (rota: Rota<string>) => boolean = (rota) => {
    if (can("update", "rota.rotas")) {
      return true;
    }
    if (authStore.isAgencyUser) {
      return agencyIsOnThisRota(authStore.user.agencyId, rota);
    }
    if (!rotaUser.value) {
      console.warn("Rota user is not initialized for access control check");
      return false;
    }
    if (
      rotaUser.value!.locations?.some((loc: string) => loc == rota.location)
    ) {
      return true;
    }
    return userIsOnThisRota(rotaUser.value!.userId, rota);
  };

  const init = async () => {
    if (authStore.isAgencyUser) {
      return true;
    }
    if (!rotaUser.value) {
      rotaUser.value = await rotaUsersStore.getMyRotaUser();
    }
  };

  return { init, rotaUser, authUserCanAccessRota };
};
/* v8 ignore end */
